import { render, staticRenderFns } from "./LoanDashboard.vue?vue&type=template&id=c59e40e6&scoped=true"
import script from "./LoanDashboard.vue?vue&type=script&lang=js"
export * from "./LoanDashboard.vue?vue&type=script&lang=js"
import style0 from "./LoanDashboard.vue?vue&type=style&index=0&id=c59e40e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59e40e6",
  null
  
)

export default component.exports